import { render, staticRenderFns } from "./ExpenseMangement.vue?vue&type=template&id=0c06e628&scoped=true"
import script from "./ExpenseMangement.vue?vue&type=script&lang=js"
export * from "./ExpenseMangement.vue?vue&type=script&lang=js"
import style0 from "./ExpenseMangement.vue?vue&type=style&index=0&id=0c06e628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c06e628",
  null
  
)

export default component.exports